import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  AfterViewChecked,
} from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormGroup, NG_VALIDATORS,
  NG_VALUE_ACCESSOR, Validator, Validators } from '@angular/forms';
import { ConciliationService } from 'app/core/services/conciliation.service';
import { Subscription } from 'rxjs';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-autocomplete-payors',
  templateUrl: './autocomplete-payors.component.html',
  styleUrls: ['./autocomplete-payors.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompletePayorsComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AutocompletePayorsComponent),
      multi: true,
    }
  ],
})
export class AutocompletePayorsComponent implements OnInit, ControlValueAccessor, Validator, OnDestroy, AfterViewChecked  {
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();
  @Input() alignButton = 'right';
  @ViewChild('payorAutoInput') payorAutoInput: ElementRef;
  @ViewChild('payorList') payorList: ElementRef;
  payorsForm: FormGroup;
  subscriptions: Subscription[] = [];
  showList: boolean;
  arrayCodeFilter = [];
  listTop = 0;
  listLeft = 0;
  private needsReposition = false;
  onChangeFn = (_: any) => { };
  onTouchedFn = (_: any) => { };

  constructor(private fb: FormBuilder,
    private conciliationService: ConciliationService
  ) {
    this.initForm();
  }

  ngOnInit() {
  }

  ngAfterViewChecked(): void {
    if (this.needsReposition && this.payorList) {
      this.updateListPosition();
      this.needsReposition = false;
    }
  }


  initForm(): void {
    this.payorsForm = this.fb.group({
      payor: [null, Validators.required]
    });
  }

  writeValue(value: any): void {
    this.payorsForm.patchValue({ payor: value });
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.payorsForm.disable();
    } else {
      this.payorsForm.enable();
    }
  }

  searchPayor(value: string): void {
    this.showList = false;
    if (value) {
      const payorControl = this.payorsForm.get('payor');
      payorControl.patchValue(value);
      this.onChangeFn(value);
      this.payorAutoInput.nativeElement.focus();
    }
  }

  onAutoComplete(val: any): void {
    if (val) {
      this.conciliationService.getPayorsByDescription({ filter: val })
      .subscribe({
        next: (resp) => {
          if (resp) {
            this.arrayCodeFilter = [];
            this.showList = true;
            this.needsReposition = true;
            this.arrayCodeFilter = resp;
          }
        }
      });
      this.onChangeFn(val);
    } else {
      this.arrayCodeFilter = [];
      this.onChangeFn(this.payorsForm.get('payor').value);
    }
  }
  @HostListener('document:click', ['$event'])
  onClickSide(event: MouseEvent): void {
    if (!this.payorAutoInput.nativeElement.contains(event.target)) {
      this.closeList();
    }
  }
  @HostListener('window:resize')
  onResize(): void {
    this.updateListPosition();
  }

  private updateListPosition(): void {
    if (!this.payorAutoInput || !this.payorList) {
      return;
    }

    const inputRect = this.payorAutoInput.nativeElement.getBoundingClientRect();
    const listHeight = this.payorList.nativeElement.offsetHeight;
    const viewportHeight = window.innerHeight;

    const spaceBelow = viewportHeight - inputRect.bottom;
    const spaceAbove = inputRect.top;

    if (spaceBelow < listHeight && spaceAbove > listHeight) {
      this.listTop = ((inputRect.top - listHeight) / viewportHeight) * 100;
    } else {
      this.listTop = (inputRect.bottom / viewportHeight) * 100;
    }

    this.listLeft = (inputRect.left / window.innerWidth) * 100;
  }



  onBlur(event: any): void {
    this.blur.emit(event);
  }

  validate(c: AbstractControl): { [key: string]: any; } {
    return this.payorsForm.valid ? null : { required: true };
  }

  closeList(): void {
    this.showList = false;
  }

  get listStyles() {
    return {
      top: `${this.listTop}%`,
      left: `${this.listLeft}%`
    };
  }

  get isListVisible() {
    return this.showList && this.arrayCodeFilter.length;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscribe: Subscription) => subscribe.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/autocomplete-payors/autocomplete-payors.component.ts